import { FC } from 'react';

import { ClockIcon } from '@rikstv/play-common/src/icons';
import {
  formatTime,
  getRatioOfCurrentTimeInRange,
  getStartEndTime,
} from '@rikstv/play-common/src/utils/date/date.utils';
import { Body, Bold, H2, H3 } from '@rikstv/shared-components';

import { Program } from '../../../forces/channels/channel.types';
import { DurationBar } from '../../durationBar/DurationBar';
import { TruncateText } from '../../truncateText/TruncateText';

import styles from './ProgramDetailsItem.module.css';

interface Props {
  program?: Program;
  isExternal: boolean;
}

export const ProgramDetailsItem: FC<Props> = ({ program, isExternal }) => {
  if (!program) {
    return (
      <div>
        <H2 className={styles.title}>Ingen sending</H2>
      </div>
    );
  }

  return (
    <div>
      <H2 className={styles.title}>{program.name}</H2>
      {program.subtitle && (
        <H3 lookLike="title-4" className={styles.episodeTitle}>
          {program.subtitle}
        </H3>
      )}
      <TruncateText lines={3} textStyle={Body}>
        {program.description}
      </TruncateText>
      {isExternal && <ExternalProgramProgress program={program} />}
    </div>
  );
};

const ExternalProgramProgress: FC<{ program: Program }> = ({ program }) => {
  const { start, end } = getStartEndTime(program.time, program.duration);
  const progress = getRatioOfCurrentTimeInRange(start, end) * 100;
  return (
    <div className={styles.liveProgress}>
      <div className={styles.progressLabel}>
        <ClockIcon iconSize={20} />
        <Bold>Sendes nå</Bold>
      </div>
      <DurationBar percent={progress} className={styles.progressBar} />
      <div>
        <time>{formatTime(start)}</time> - <time>{formatTime(end)}</time>
      </div>
    </div>
  );
};
